import { defineMessages } from 'react-intl'

const scope = 'app.components.EmployeesSection'

export default defineMessages({
  employees: {
    id: `${scope}.employees`,
    defaultMessage: 'Employees Locations',
  },
  identified: {
    id: `${scope}.identified`,
    defaultMessage: '{count} Identified Employees',
  },
  option: {
    id: `${scope}.option`,
    defaultMessage: '{label} ({count})',
  },
})
